<div style="padding: 24px;">
  <h5 mat-dialog-title class="text-center">Conversión manual</h5>
  <div mat-dialog-content>
    <!--begin::Form-->
    <form class="form" [formGroup]="conversionForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
      <div class="form-group">
        <p><strong>ID: </strong>{{data.row.id}}</p>
        <p><strong>Fecha de creación: </strong>{{data.row.createdAt | date: 'MMMM d, y'}}</p>
        <mat-form-field class="w-100">
          <mat-label>País/región</mat-label>
          <input matInput type="text" placeholder="ej. EEUU"
                 formControlName="country" autocomplete="off" readonly/>
          <mat-error *ngIf="isControlHasError('country', 'required')">
            <strong>Campo requerido</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100">
          <mat-label>Divisa</mat-label>
          <input matInput type="text" placeholder="ej. Dólar"
                 formControlName="currency" autocomplete="off" readonly/>
          <mat-error *ngIf="isControlHasError('currency', 'required')">
            <strong>Campo requerido</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100">
          <mat-label>Divisa símbolo</mat-label>
          <input matInput type="text" placeholder="ej. $"
                 formControlName="symbol" autocomplete="off" readonly/>
          <mat-error *ngIf="isControlHasError('symbol', 'required')">
            <strong>Campo requerido</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100">
          <mat-label>Conversión</mat-label>
          <input matInput type="number"
                 formControlName="conversion" autocomplete="off"/>
          <mat-error *ngIf="isControlHasError('conversion', 'required')">
            <strong>Campo requerido</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </form>
    <!--end::Form-->
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Cerrar</button>
    <button mat-button cdkFocusInitial (click)="addTRMHandbook(conversionForm)">Guardar</button>
  </div>
</div>
